"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeTokenPaymentDetector = void 0;
const types_1 = require("@requestnetwork/types");
const reference_based_detector_1 = require("./reference-based-detector");
/**
 * Handle payment detection for native token payment
 */
class NativeTokenPaymentDetector extends reference_based_detector_1.ReferenceBasedDetector {
    constructor({ network, advancedLogic, currencyManager, getSubgraphClient, }) {
        const extensionId = types_1.ExtensionTypes.PAYMENT_NETWORK_ID.NATIVE_TOKEN;
        const extension = advancedLogic.getNativeTokenExtensionForNetwork(network);
        if (!extension) {
            throw new Error(`the ${extensionId} extension is not supported for the network ${network}`);
        }
        super(extensionId, extension, currencyManager);
        this.getSubgraphClient = getSubgraphClient;
        this.network = network;
    }
}
exports.NativeTokenPaymentDetector = NativeTokenPaymentDetector;
